import type { CategoryLinksData } from 'tradera/apps/tradera/start-page/components/category-links/category-links';
import type { PopularCategoriesData } from 'tradera/apps/tradera/start-page/components/popular-categories/popular-categories';
import type { CustomUrlSectionData } from 'tradera/apps/tradera/start-page/components/item-list/item-section-custom-url';

export type StartPageInitData = {
    isLoggedIn?: boolean;
    startPageResponse?: { config: string };
};

export enum STATUS {
    FETCH_FAILED = 'FETCH_FAILED',
    HAS_DATA = 'HAS_DATA',
    NOT_FETCHED = 'NOT_FETCHED'
}

type StartpageContentDataHiddenOn = { hiddenOn: string[] };

export type StartPageContent = {
    type: string;
    id?: string;
    data?:
        | StartpageContentDataHiddenOn
        | CategoryLinksData
        | PopularCategoriesData
        | CustomUrlSectionData;
};

export type BannerLinkIcon = {
    baseUrl: string;
};

type BannerLink = {
    text: string;
    url: string;
    icon?: BannerLinkIcon;
};

export type MediaItem = {
    smallUrl: string;
    mediumUrl: string;
    largeUrl: string;
};

export type MediaItemWithBaseUrl = MediaItem & {
    baseUrl: string;
};

type StartPageHeader = {
    displayRecentSearches?: boolean;
    displayTrendingSearches?: boolean;
    bannerLinks?: BannerLink[];
    backgroundVideo?: MediaItem;
    backgroundImage?: MediaItemWithBaseUrl | null;
    taglineDesktop?: string;
    taglineMobile?: string;
};

type StartPageConfig = {
    content: StartPageContent[];
    header: StartPageHeader;
};

export type StartPageConfigInitData = {
    contentLoggedIn: StartPageContent[];
    contentLoggedOut: StartPageContent[];
    header: StartPageHeader;
};

export type StartPageInitialState = {
    itemQueryRandomNumber: number;
    status: STATUS;
    config: StartPageConfig;
};
